/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Country } from '../models/country';
@Injectable({
  providedIn: 'root',
})
class CountriesService extends __BaseService {
  static readonly getAllCountriesPath = '/countries';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Get the list of all countries
   */
  getAllCountriesResponse(): __Observable<__StrictHttpResponse<Array<Country>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/countries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Country>>;
      })
    );
  }
  /**
   * @return Get the list of all countries
   */
  getAllCountries(): __Observable<Array<Country>> {
    return this.getAllCountriesResponse().pipe(
      __map(_r => _r.body as Array<Country>)
    );
  }
}

module CountriesService {
}

export { CountriesService }
